import axios, { AxiosResponse } from 'axios';
import { ensureSession, getAccessToken, handleUnauthorized } from '../auth';
import { getUserFacingError } from './userFacingError';

function isPublicAuthUrl(url: string): boolean {
  const path = url.split('?')[0];
  return (
    path.endsWith('/login') ||
    path.endsWith('/forgot_password') ||
    path.endsWith('/auth/refresh') ||
    (path.endsWith('/reset_password') && !path.includes('/admin/'))
  );
}

async function postApi(url: string, payload: any): Promise<any> {
  try {
    const isPublicAuth = isPublicAuthUrl(url);

    if (!isPublicAuth) {
      const ok = await ensureSession();
      if (!ok) {
        handleUnauthorized();
        throw new Error('Session expired — please log in');
      }
    }

    const response: AxiosResponse = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${getAccessToken()}`
      },
    });
    return response;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        const isPublicAuth = isPublicAuthUrl(url);
        if (!isPublicAuth) {
          handleUnauthorized();
        }
      }
      // Prefer body message when present (login soft/hard errors)
      const bodyMsg = error.response?.data?.message;
      if (bodyMsg) {
        const err = new Error(bodyMsg) as Error & { response?: any; status?: number };
        err.response = error.response;
        err.status = error.response?.status;
        throw err;
      }
      throw new Error(getUserFacingError(error));
    }
    throw new Error(getUserFacingError(error));
  }
}

export default postApi;
